(function () {
    'use strict';

    // @ngInject
    function ConfirmPremiumControllerCtor($scope, $injector, AnalyticsService, $modalInstance, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ConfirmPremiumController';
        AnalyticsService.trackPageView(this, 'ConfirmPremiumView');

        this.modalInstance = $modalInstance;
        this.AppStates = AppStates;
    }

    Controllers.ConfirmPremiumController = Class(Controllers.BaseController, {
        constructor: ConfirmPremiumControllerCtor,

        cancel: function cancel() {
            this.modalInstance.dismiss();
        },

        confirm: function confirm() {
            this.goToState(this.AppStates.root_core_navigation_settings_companySettings_subscription);
            this.modalInstance.close(true);
        }
    });
}());
